export default __webpack_public_path__ + "static/media/logs.96b2355d.jpg";